<template>
  <div class="m-12 mx-0 my-0 flex flex-col w-auto">
    <div ref="narrativeCanvas" style="overflow:scroll">
      <main
        id="narrative-canvas"
        class="w-auto relative"
        style="height:12000px"
      >
        <h1
          class="fixed bg-gray-600 text-gray-50 p-4 rounded-br-md
          cursor-pointer uppercase opacity-25 hover:opacity-100
          hover:bg-blue-500"
          style="top:5px, left:5px; z-index:10000"
          @click="
            $router.push({
              name: 'Narrative',
              params: { narrativeName: narrativeName, username: username },
            })
          "
        >
          End Narrative
        </h1>
        <div
          :id="e.Oid + '-container'"
          v-for="(e, idx) in narrative.elements"
          v-if="e.type == 'IMAGE' && e.isBackground"
          style="position: relative; z-index:-1; opacity: 0"
          class="downscale"
        >
          <img
            :src="e.url"
            style="position: absolute; top:0; left: 0; height:100%; width: 100%
            opacity: 0; z-index:-1; object-fit:cover; object-position: 50% 50%"
          />
        </div>

        <div class="flex flex-col items-center justify-center">
          <div
            class="text-4xl mb-4 font-semibold text-blue-500 mt-24 uppercase
            animate-bounce"
            @click="createNarrative"
          >
            Scroll
          </div>

          <!-- DOWNWARD ARROW -->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            class="h-16 text-blue-500 animate-bounce"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M16 17l-4 4m0 0l-4-4m4 4V3"
            />
          </svg>
          <!-- END DOWNWARD ARROW -->
        </div>

        <!-- CONTENT INJECTION HAPPENS HERE -->
        <div
          :id="element.Oid + '-container'"
          v-for="(element, idx) in narrative.elements"
          style="position: relative; z-index: 1000"
        >
          <narrative-element :element="element"></narrative-element>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
// import Component from "../component_location"
import { reportError } from "@/utils.js";
import NarrativeElement from "@/components/NarrativeElements/NarrativeElement.vue";
import Vue from "vue";
import VueScrollmagic from "vue-scrollmagic";
import { TweenMax, TimelineMax } from "gsap";

Vue.use(VueScrollmagic, { refreshInterval: 100 });

export default {
  components: { NarrativeElement },

  // props: ["username", "narrativeName"],
  props: ["narrative"],

  data() {
    return {};
  },

  watch: {},

  methods: {
    triggerPresent() {
      this.narrative.elements.forEach((e) => {
        if ((e.type = "TRIGGER")) {
          return true;
        }
        return false;
      });
    },

    createNarrative() {
      // Attach scrollmagic to the narrativeCanvas
      this.$scrollmagic.attachTo(this.$refs.narrativeCanvas);
      var currentTriggerId = "";
      var currentTrigger = null;
      var scenes = [];
      var currentZeeIndex = 10;
      var currentBackground = null;
      this.narrative.elements.forEach((e) => {
        // SET DEFAULTS.
        if (!e.triggerHook) {
          e.triggerHook = 0.5;
        }
        if (!e.duration) {
          e.duration = 200;
        }
        if (!e.animationHook) {
          e.animationHook = 0.5;
        }
        // SET NARRATIVE TRIGGERS.
        if (e.type == "TRIGGER") {
          currentTriggerId = `${e.Oid}-container`;
          currentTrigger = document.getElementById(currentTriggerId);
        }

        var scene = null;
        var pinScene = null;
        var auxiliaryScene = null;
        if (e.type == "COLOR") {
          // Change background color.
          scene = this.$scrollmagic
            .scene({
              triggerElement: currentTrigger,
              triggerHook: e.animationHook,
              duration: e.duration,
            })
            .setTween("#narrative-canvas", 0.5, {
              css: { backgroundColor: e.backgroundColor },
            });

          if (currentBackground) {
            // FADE EXISTING BACKGROUND IMAGE.
            auxiliaryScene = this.$scrollmagic
              .scene({
                triggerElement: currentTrigger,
                triggerHook: e.animationHook,
                duration: e.duration,
              })
              .setTween(currentBackground, 0.5, {
                css: { opacity: 0, zIndex: -1 },
              });
            currentBackground = null; // NO BACKGROUND IMAGE/VIDEO EXISTS NOW.
          }
        } else if (e.type == "IMAGE" && e.isBackground) {
          scene = this.$scrollmagic
            .scene({
              triggerElement: currentTrigger,
              triggerHook: e.animationHook,
              duration: e.duration,
            })
            .setTween(`#${e.Oid}-container`, 0.5, {
              css: { opacity: 0.999, zIndex: currentZeeIndex },
            });

          if (currentBackground) {
            auxiliaryScene = this.$scrollmagic
              .scene({
                triggerElement: currentTrigger,
                triggerHook: e.animationHook,
                duration: e.duration,
              })
              .setTween(currentBackground, 0.5, {
                css: { opacity: 0, zIndex: -1 },
              });
          }
          currentBackground = `#${e.Oid}-container`;
          currentZeeIndex += 1;
        } else {
          // a non-background element, possibly animated and/or pinned.
          scene = this.$scrollmagic
            .scene({
              triggerElement: currentTrigger,
              triggerHook: e.animationHook,
              duration: e.duration,
            })
            .setTween("#" + e.Oid + "-element", 0.5, {
              css: {
                opacity: e.endOpacity / 100,
                left: `${e.endPosition}%`,
                scale: e.endScale,
                width: `${e.endWidth}$`,
              },
            });
          if (e.pinElement) {
            var pinTriggerId = `${e.Oid}-container`;
            var pinTrigger = document.getElementById(pinTriggerId);
            pinScene = this.$scrollmagic
              .scene({
                triggerElement: pinTrigger,
                triggerHook: e.triggerHook,
                duration: e.pinDuration,
              })
              .setPin(pinTrigger);
          }
        }

        // ADD SCENES, IF THEY EXIST.
        if (scene) {
          scenes.push(scene);
        }
        if (pinScene) {
          scenes.push(pinScene);
        }
        if (auxiliaryScene) {
          scenes.push(auxiliaryScene);
          auxiliaryScene = null;
        }
      });

      scenes.forEach((s) => {
        this.$refs.narrativeCanvas.$scrollmagic.addScene(s);
        // this.$refs.narrativeCanvas.$scrollmagic.scrollTo(400);
        this.$scrollmagic.addScene(s);
      });
    },
  },

  updated() {
    this.createNarrative();
  },

  computed: {
    // narrative() {
    //   return this.$store.state.narratives.current;
    // },
  },

  mounted() {
    this.createNarrative();
    // let details = {
    //   username: this.username,
    //   narrativeName: this.narrativeName,
    // };
    // this.$store.dispatch("narratives/getNarrative", details);
  },
};
</script>

<style>
.downscale {
  transform: scale(0.7, 0.7);
  transform-origin: 0, 0;
}
</style>
